<section class="md-page customer-item-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="flex align-items-center justify-content-between mb-3">
    <h2 class="m-0">Customer Items</h2>
    <p-button label="New Customer Item" icon="pi pi-plus" (onClick)="onNewCustomerItem()"></p-button>
  </div>

  <div class="customer-item-filters mb-4 p-4 border-round-2xl">
    <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6 lg:col-4">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input pInputText formControlName="customerItemNumber" id="customerItemNumberFilter" class="w-full" />
              <label for="customerItemNumberFilter">Customer Item Number</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <div class="field col-12 md:col-8 lg:col-8">
          <p-inputgroup>
            <p-inputgroup-addon><i class="pi pi-align-left"></i></p-inputgroup-addon>
            <p-iftalabel>
              <input pInputText formControlName="customerItemDescription" id="customerItemDescriptionFilter" class="w-full" />
              <label for="customerItemDescriptionFilter">Description</label>
            </p-iftalabel>
          </p-inputgroup>
        </div>

        <app-entity-dropdown-picker
          formControlName="customer"
          [adapter]="customerPickerAdapter"
          inputId="customerFilter"
          label="Customer"
          placeholder="Select a Customer"
          filterPlaceholder="Filter customers"
          columnClass="col-12 md:col-12 lg:col-8"
          addonIconClass="pi pi-users"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="tamerItem"
          [adapter]="itemPickerAdapter"
          inputId="tamerItemFilter"
          label="Tamer Item"
          placeholder="Any tamer item"
          filterPlaceholder="Filter tamer items"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-box"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="brand"
          [adapter]="brandPickerAdapter"
          inputId="brandFilter"
          label="Brand"
          placeholder="Any brand"
          filterPlaceholder="Filter brands"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-tags"
        ></app-entity-dropdown-picker>

        <app-entity-dropdown-picker
          formControlName="subBrand"
          [adapter]="subBrandPickerAdapter"
          inputId="subBrandFilter"
          label="Sub Brand"
          placeholder="Any sub brand"
          filterPlaceholder="Filter sub brands"
          columnClass="col-12 md:col-6 lg:col-4"
          addonIconClass="pi pi-sitemap"
        ></app-entity-dropdown-picker>
      </div>

      <div class="flex justify-content-end gap-2 mt-4">
        <p-button
          label="Reset"
          icon="pi pi-refresh"
          styleClass="p-button-secondary"
          type="button"
          (onClick)="onReset()"
        ></p-button>
        <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
      </div>
    </form>
  </div>

  <p-table
    #dt
    [value]="customerItems"
    [rows]="rows"
    [paginator]="true"
    [lazy]="true"
    [loading]="isLoading"
    [totalRecords]="totalRecords"
    (onLazyLoad)="loadCustomerItems($event)"
    dataKey="customerItemId"
    styleClass="p-datatable-striped md-data-table customer-item-table"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 10rem">Actions</th>
        <th>Customer Item #</th>
        <th>Description</th>
        <th>Customer</th>
        <th>Tamer Item</th>
        <th>Brand</th>
        <th>Sub Brand</th>
        <th>Customer UOM</th>
        <th>Item UOM</th>
        <th>Price</th>
        <th>Case Count</th>
        <th>Pallet Count</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-customerItem>
      <tr>
        <td>
          <div class="flex gap-2">
            <p-button
              icon="pi pi-pencil"
              styleClass="p-button-rounded p-button-success"
              (onClick)="editCustomerItem(customerItem.customerItemId!)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              styleClass="p-button-rounded p-button-danger"
              (onClick)="deleteCustomerItem(customerItem)"
            ></p-button>
          </div>
        </td>
        <td>{{ customerItem.customerItemNumber }}</td>
        <td>{{ customerItem.customerItemDescription || '-' }}</td>
        <td>{{ formatCustomer(customerItem.customer) }}</td>
        <td>{{ formatItem(customerItem.tamerItem) }}</td>
        <td>{{ customerItem.brand?.brandName || '-' }}</td>
        <td>{{ customerItem.subBrand?.subBrandName || '-' }}</td>
        <td>{{ customerItem.customerItemUom || '-' }}</td>
        <td>{{ customerItem.itemUom || '-' }}</td>
        <td>{{ customerItem.customerItemPrice ?? '-' }}</td>
        <td>{{ customerItem.caseCount ?? '-' }}</td>
        <td>{{ customerItem.palletCount ?? '-' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12">No customer items found.</td>
      </tr>
    </ng-template>
  </p-table>
</section>
